export default __webpack_public_path__ + "static/429-8293d7a46bd1469b8cc82a2db4261fd6.gif";